import { c as _c } from "react/compiler-runtime";
import SvgChevronleft from '@common/icon/SvgChevronleft';
import SvgChevronright from '@common/icon/SvgChevronright';
import { cn } from '@core/utils';
import { createPortal } from 'react-dom';
interface SideNavButtonsProps {
  positions: {
    left: {
      top: number;
      left: number;
    };
    right: {
      top: number;
      right: number;
    };
  };
  onNextClick: () => void;
  onPrevClick: () => void;
  isNextDisabled: boolean;
  isPrevDisabled: boolean;
}
export const SideNavButtons = t0 => {
  const $ = _c(23);
  const {
    positions,
    onNextClick,
    onPrevClick,
    isNextDisabled,
    isPrevDisabled
  } = t0;
  if (typeof window === "undefined") {
    return null;
  }
  let t1;
  if ($[0] !== isPrevDisabled) {
    t1 = cn("fixed z-50 size-52 -translate-y-1/2 rounded-pill border-1 border-Gray-300 bg-Gray-white flex-center", {
      "opacity-50 cursor-not-allowed": isPrevDisabled
    });
    $[0] = isPrevDisabled;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== positions.left.left || $[3] !== positions.left.top) {
    t2 = {
      top: positions.left.top,
      left: positions.left.left
    };
    $[2] = positions.left.left;
    $[3] = positions.left.top;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = isPrevDisabled ? undefined : onPrevClick;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SvgChevronleft className="size-36 text-Gray-600" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t5 = <button type="button" aria-label={"\uC774\uC804 \uB9AC\uBDF0"} className={t1} style={t2} onClick={t3}>{t4}</button>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== isNextDisabled) {
    t6 = cn("fixed z-50 size-52 -translate-y-1/2 rounded-pill border-1 border-Gray-300 bg-Gray-white flex-center", {
      "opacity-50 cursor-not-allowed": isNextDisabled
    });
    $[10] = isNextDisabled;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== positions.right.right || $[13] !== positions.right.top) {
    t7 = {
      top: positions.right.top,
      right: positions.right.right
    };
    $[12] = positions.right.right;
    $[13] = positions.right.top;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = isNextDisabled ? undefined : onNextClick;
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <SvgChevronright className="size-36 text-Gray-600" />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t10 = <button type="button" aria-label={"\uB2E4\uC74C \uB9AC\uBDF0"} className={t6} style={t7} onClick={t8}>{t9}</button>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t5) {
    t11 = createPortal(<>{t5}{t10}</>, document.body);
    $[20] = t10;
    $[21] = t5;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};